import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Skull } from "lucide-react";

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [hostToken, setHostToken] = useState(null);
  const polling = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setHostToken(data.host_token);
          setStatus("paid");
          setTimeout(() => navigate(`/dashboard/${data.host_token}`), 1500);
          return;
        }
        if (data.payment_status === "expired" || data.payment_status === "failed") {
          setStatus("failed");
          return;
        }
        polling.current += 1;
        if (polling.current > 20) {
          setStatus("timeout");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId, navigate]);

  return (
    <div className="grain min-h-screen flex items-center justify-center" data-testid="payment-success-page">
      <div className="text-center max-w-md px-6">
        {status === "checking" && (
          <>
            <Loader2 size={48} className="mx-auto text-[#8b0000] animate-spin mb-6" />
            <div className="font-display text-3xl mb-2">Confirming payment...</div>
            <div className="text-[#a39797]">Opening your case file.</div>
          </>
        )}
        {status === "paid" && (
          <>
            <Skull size={48} className="mx-auto text-[#8b0000] mb-6" />
            <div className="font-display text-4xl mb-3">Case open.</div>
            <div className="text-[#a39797]">Taking you to your dashboard...</div>
          </>
        )}
        {(status === "failed" || status === "error" || status === "timeout") && (
          <>
            <div className="font-display text-3xl mb-2 text-[#b30000]">Something went wrong.</div>
            <div className="text-[#a39797] mb-6">We couldn't confirm your payment.</div>
            <button className="btn-ghost" onClick={() => navigate("/checkout")} data-testid="retry-checkout">
              Try again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
